"use client";

import { useResendOTP } from "@repo/lib/hooks/common";
import { Button, InputOTP, InputOTPGroup, InputOTPSlot, LoadingDots } from "@repo/ui";
import { useTranslations } from "next-intl";
const VerifyOtpForm = ({
  formValues,
  handleSubmit,
  otpValue,
  setOtpValue,
  isPending
}) => {
  const {
    timer,
    isResendDisabled,
    handleResend,
    isPendingGetOTP
  } = useResendOTP(formValues);
  const t = useTranslations("Common");
  const isSubmitEnabled = otpValue?.length !== 6;
  const inputCount = 6;
  const inputWidth = {
    4: "w-[25%]",
    6: "w-[16.6667%]"
  };
  const inputStyle = `h-[46px] ${inputWidth[inputCount]}`;
  return <form onSubmit={handleSubmit} data-sentry-component="VerifyOtpForm" data-sentry-source-file="VerifyOtpForm.jsx">
      <div className="mb-6">
        <InputOTP maxLength={6} autoFocus value={otpValue} onChange={otpValue => setOtpValue(otpValue)} data-sentry-element="InputOTP" data-sentry-source-file="VerifyOtpForm.jsx">
          <InputOTPGroup className="w-full" data-sentry-element="InputOTPGroup" data-sentry-source-file="VerifyOtpForm.jsx">
            {[...Array(6)].map((_, i) => <InputOTPSlot index={i} key={i} className={inputStyle} />)}
          </InputOTPGroup>
        </InputOTP>
      </div>
      <Button size="md" type="submit" className="w-full" variant="primary" disabled={isPending || isSubmitEnabled} data-sentry-element="Button" data-sentry-source-file="VerifyOtpForm.jsx">
        {isPending ? <LoadingDots className="bg-white" /> : <span className="flex items-center justify-center">
            {t("Verify")}
          </span>}
      </Button>
      <p className="pt-2 text-center text-sm">
        {t("Check_Your_Spam_folder_For_Email")}
      </p>
      <div className="mt-4 flex justify-center space-x-1 text-sm">
        {isResendDisabled ? <span className="text-supportiveMediumGray font-medium">
            {t("Resend_In")}{" "}
            <span className="text-supportiveBlack">
              {isResendDisabled && `${timer}`}
            </span>
          </span> : <>
            <span>{t("Resend_Text")}</span>{" "}
            <button className="text-brown hover:underline" disabled={isResendDisabled || isPendingGetOTP} onClick={e => handleResend(e)}>
              {t("Resend")}
            </button>
          </>}
      </div>
    </form>;
};
export default VerifyOtpForm;